import axios from 'axios';
import { useQuery } from 'react-query';

import { IResponseAPI } from 'models/interfaces/IResponseAPI';
import { useSessionStore } from 'session/useSessionStore';

export function useGetTextForViewer(fileToken: string | (string | null)[] | null, ) {
    const {tenantConfig, jwtToken} = useSessionStore(state => ({
        tenantConfig: state.tenantConfiguration,
        jwtToken: state.jwtToken
    }));

    return useQuery('getTextForViewer' + fileToken, async () => {
        const response = await axios.get(`${tenantConfig?.endpoints.fileManager}/FileManager/FileManager/GetFileForViewer?fileToken=${fileToken}`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${jwtToken}`
            },
        });

        console.log(response.data);
        return response.data;
    }, {
        refetchOnWindowFocus: false,
        enabled: fileToken !== null && fileToken !== undefined && fileToken !== '',
    });
}